import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { toastSuccess, toastError } from "@/lib/toast"
import { useLanguage } from "@/hooks/useLanguage"
import { loadConektaScript, mountConektaWidget } from "@/lib/conekta"

interface PaymentAreaProps {
  checkoutId: string
  text: any
  clearCart: () => void
}

export const PaymentArea: React.FC<PaymentAreaProps> = ({
  checkoutId,
  text,
  clearCart,
}) => {
  const navigate = useNavigate()

  useEffect(() => {
    let cancelMount: (() => void) | undefined

    loadConektaScript()
      .then(() => {
        cancelMount = mountConektaWidget({
          containerId: "conekta-checkout-container",
          checkoutRequestId: checkoutId,
          publicKey: import.meta.env.VITE_CONEKTA_PUBLIC_KEY,
          onFinalize: () => {
            clearCart()
            toastSuccess(text.orderSuccess)
            navigate("/order-tracking")
          },
        })
      })
      .catch(() => toastError("Failed to load payment system."))

    return () => cancelMount?.()
  }, [checkoutId, navigate, text.orderSuccess, clearCart])

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex items-center gap-4">
        <div className="flex h-8 w-12 items-center justify-center border-l-[1px] border-accent bg-foreground/[0.03] font-mono text-xs font-black tracking-widest text-accent shadow-sm">
          [02]
        </div>
        <div className="space-y-2">
          <h2 className="font-display text-3xl uppercase tracking-widest">{text.paymentMethod}</h2>
          <div className="h-[1px] w-8 bg-accent" />
        </div>
      </div>

      <div className="overflow-hidden rounded-lg bg-foreground/10 p-px shadow-2xl">
        <div 
          className="min-h-[700px] bg-background p-4 md:p-8" 
          id="conekta-checkout-container" 
          style={{ height: '700px' }}
        />
      </div>
    </div>
  )
}

